import { PreviewContent } from '../types.d';

export const isValidJSON = (jsonString: string): boolean => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch {
    return false;
  }
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getDefaultTestData = (templateType: string): Record<string, any> => {
  const defaultDataMap: Record<string, Record<string, any>> = {
    order_confirmation: {
      user_name: 'John Doe',
      order_id: 'ORD-001',
      total_price: '$50.00',
      order_type: 'Pickup',
      merchant_name: 'Test Restaurant',
      order_items: '2x Burger, 1x Fries',
    },
    user_registration: {
      user_name: 'Jane Doe',
      app_name: 'Elio & Papas',
      verification_url: 'https://example.com/verify?code=abc123',
      verification_code: 'ABC123DEF456',
    },
    password_reset: {
      user_name: 'John Smith',
      reset_url: 'https://example.com/reset?token=xyz789',
      reset_code: 'XYZ789',
    },
    order_status_update: {
      user_name: 'Jane Smith',
      order_id: 'ORD-002',
      status: 'Ready for pickup',
      merchant_name: 'Test Restaurant',
      estimated_time: '15 minutes',
    },
    promotional: {
      user_name: 'John Doe',
      app_name: 'Elio & Papas',
      offer_title: 'Special Discount',
      offer_description: '50% off on your next order',
      coupon_code: 'SPECIAL50',
      expiry_date: '2025-03-31',
    },
  };

  return defaultDataMap[templateType] || {};
};

export const updatePreview = (
  template: any,
  variables: Record<string, any>
): PreviewContent => {
  try {
    let subject = template?.subject || '';
    let htmlContent = template?.htmlContent || '';
    let textContent = template?.textContent || '';

    // Replace variables in content
    Object.entries(variables).forEach(([key, value]) => {
      const placeholder = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
      const stringValue = String(value || '');

      subject = subject.replace(placeholder, stringValue);
      htmlContent = htmlContent.replace(placeholder, stringValue);
      textContent = textContent.replace(placeholder, stringValue);
    });

    return {
      subject,
      html: htmlContent,
      text: textContent,
    };
  } catch (error) {
    console.error('Error updating preview:', error);
    return {
      subject: '',
      html: '',
      text: '',
    };
  }
};

export const parseTestData = (testDataString: string): Record<string, any> | null => {
  try {
    return JSON.parse(testDataString);
  } catch {
    return null;
  }
};

export const formatVariableValue = (value: any, maxLength: number = 50): string => {
  const stringValue = String(value);
  return stringValue.length > maxLength ? stringValue.substring(0, maxLength) + '...' : stringValue;
};
